/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

/**
 * Standard error response object
 */
export type PutApiWorkspaceServiceV1WorkspacesErrorResponseData = {
  error: string;
  code?: string | undefined;
  details?: any | null | undefined;
};

/**
 * Standard error response object
 */
export class PutApiWorkspaceServiceV1WorkspacesErrorResponse extends Error {
  error: string;
  code?: string | undefined;
  details?: any | null | undefined;

  /** The original data that was passed to this error instance. */
  data$: PutApiWorkspaceServiceV1WorkspacesErrorResponseData;

  constructor(err: PutApiWorkspaceServiceV1WorkspacesErrorResponseData) {
    const message = "message" in err && typeof err.message === "string"
      ? err.message
      : `API error occurred: ${JSON.stringify(err)}`;
    super(message);
    this.data$ = err;

    this.error = err.error;
    if (err.code != null) this.code = err.code;
    if (err.details != null) this.details = err.details;

    this.name = "PutApiWorkspaceServiceV1WorkspacesErrorResponse";
  }
}

/** @internal */
export const PutApiWorkspaceServiceV1WorkspacesErrorResponse$inboundSchema:
  z.ZodType<
    PutApiWorkspaceServiceV1WorkspacesErrorResponse,
    z.ZodTypeDef,
    unknown
  > = z.object({
    error: z.string(),
    code: z.string().optional(),
    details: z.nullable(z.any()).optional(),
  })
    .transform((v) => {
      return new PutApiWorkspaceServiceV1WorkspacesErrorResponse(v);
    });

/** @internal */
export type PutApiWorkspaceServiceV1WorkspacesErrorResponse$Outbound = {
  error: string;
  code?: string | undefined;
  details?: any | null | undefined;
};

/** @internal */
export const PutApiWorkspaceServiceV1WorkspacesErrorResponse$outboundSchema:
  z.ZodType<
    PutApiWorkspaceServiceV1WorkspacesErrorResponse$Outbound,
    z.ZodTypeDef,
    PutApiWorkspaceServiceV1WorkspacesErrorResponse
  > = z.instanceof(PutApiWorkspaceServiceV1WorkspacesErrorResponse)
    .transform(v => v.data$)
    .pipe(z.object({
      error: z.string(),
      code: z.string().optional(),
      details: z.nullable(z.any()).optional(),
    }));

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PutApiWorkspaceServiceV1WorkspacesErrorResponse$ {
  /** @deprecated use `PutApiWorkspaceServiceV1WorkspacesErrorResponse$inboundSchema` instead. */
  export const inboundSchema =
    PutApiWorkspaceServiceV1WorkspacesErrorResponse$inboundSchema;
  /** @deprecated use `PutApiWorkspaceServiceV1WorkspacesErrorResponse$outboundSchema` instead. */
  export const outboundSchema =
    PutApiWorkspaceServiceV1WorkspacesErrorResponse$outboundSchema;
  /** @deprecated use `PutApiWorkspaceServiceV1WorkspacesErrorResponse$Outbound` instead. */
  export type Outbound =
    PutApiWorkspaceServiceV1WorkspacesErrorResponse$Outbound;
}
